import { date } from '../../lib/helpers';
import { headers, search, editedItem, defaultItem} from './attributes';


export default {
  data: () => ({
    search,
    dateMenu: false,
    dateFormatted: '',
    show: false,
    limit: '5',
    page: '1',
    options: {},
    dialog: false,
    headers,
    editedIndex: -1,
    editedItem,
    defaultItem,
    selectedRow: '',
  }),

  computed: {
    flashErrorMessage() {
      return this.$store.state.nnsManagement.flashErrorMessage;
    },

    flashError: {
      get() {
        return this.$store.state.nnsManagement.flashError;
      },
      set() {
        this.$store.commit('nnsManagement/setFlashErrorMessage', '');
      },
    },
    loading() {
      return this.$store.state.nnsManagement.loading;
    },
    allData() {
      return this.$store.state.nnsManagement.allData;
    },
    totalData() {
      return this.$store.state.nnsManagement.totalData;
    },
    totalPage() {
      return this.$store.state.nnsManagement.totalPage;
    },
  },

  watch: {
    dialog(val) {
      if (!val) this.close();
    },
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },

    show() {
      if (!this.show) {
        this.search.bank_code = '';
        this.search.bank_nns = '';
        this.search.bank_name = '';
        this.search.brand_name = '';
        this.search.created_at = '';
        this.$nextTick(() => {
          this.getData();
        });
      }
    },

    'search.created_at': {
      handler() {
        this.dateFormatted = this.formatDate(this.search.created_at);
        this.getData();
      },
    },
  },

  methods: {
    addItem() {
      this.dialog = true;
    },
    selectRow(index) {
      if (this.selectedRow !== index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    clearSearch() {
      this.search.bank_code = '';
      this.search.bank_nns = '';
      this.search.bank_name = '';
      this.search.brand_name = '';
      this.search.created_at = '';
      this.$nextTick(() => {
        this.getData();
      });
    },

    formatDate(dateVal) {
      if (!dateVal) return null;

      const [year, month, day] = dateVal.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate(dateVal) {
      if (!dateVal) return null;

      const [day, month, year] = dateVal.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },

    getData() {
      this.$store.commit('nnsManagement/setFlashErrorMessage', '');
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store
        .dispatch('nnsManagement/getData', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
        })
        .then(() => {
          if (this.totalPage < page) {
            if (this.totalPage === 0) {
              this.options.page = 1;
            } else {
              this.options.page = this.totalPage;
            }
          }
        });
    },

    editItem(item) {
      this.editedIndex = this.$store.state.nnsManagement.allData.indexOf(item);
      this.editedItem = { ...item };
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },
  },
};